import { Component, forwardRef, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormControl, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { PageContentService, SessionStorageService } from '../../core/index.service';
import { PageContent } from '../../core/index.model';

@Component({
    selector: 'pnx-check',
    templateUrl: 'checkbox.control.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CheckControl), multi: true }
    ]
})
export class CheckControl implements ControlValueAccessor {

    @Input() labelId: string = '';
    @Input() defaultLabel: string = '';
    @Input() pagecontent: PageContent;

    @Input() label: string = '';
    @Input() labelstyle: string = '';
    @Input() checkcontainerstyle: string = 'col-md-9';
    @Input('value') _value: any;
    @Input() disable: boolean = false;
    @Output() onChecked: EventEmitter<any> = new EventEmitter<any>();

    constructor(private pageContentService: PageContentService,
        private storageService: SessionStorageService) {
    }

    ngOnInit() {
        if (this.pagecontent) {
            if (!this.pageContentService.pageContent) {
                this.pageContentService.pageContent = this.pagecontent;
            }
        }
    }
    ngOnChanges(Changes: SimpleChanges) {

        let labelValue = (this.labelId) ? this.pageContentService.getKeyTxt(this.labelId, this.storageService.getLang()) : this.label;
        this.label = (labelValue) ? labelValue : this.defaultLabel;
    }

    propagateChange: any = () => { };

    get value() {
        return this._value;
    }

    set value(val) {
        this._value = val;
        this.propagateChange(val);
    }

    checked(event) {
        this.value = event.checked; // Modified by Punithavathy for CRM# 73402 on 01/03/18
        this.onChecked.emit(this.value);
    }

    writeValue(value): void {
        this.value = value;
    }

    registerOnChange(fn): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn): void { }

    setDisabledState(isDisabled: boolean): void {
        
    }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/checkbox.control.ts